import { useCallback, useEffect, useMemo, useState } from "react"
import {
    Box, Select, Autocomplete, Card, TextField,
    TableCell, Tooltip,
    Table,
    TableHead,
    TableRow,
    TableBody,
    ListItem,
    ListItemText,
    MenuItem
} from '@mui/material';
import { Colors } from '../../../../Styles/Colors';
import ShowComponents from "../Common/ShowComponent";
import { renderIconButton, renderTitle } from "../Common/DocCommonComponent";
import { Serviceurls } from "../../../../Utility/API/Serviceurls";
import { CommonDeleteButton, CommonEditButton, DeletePopup } from "../../../../Components/Common Components/CommonComponents";
import { ImagePaths } from "../../../../Utility/ImagePaths";
import RestAPIService from "../../../../Utility/Services/RestAPIService";
import { common } from "@mui/material/colors";
import CommonValidation from "../../../../Components/CommonFunctions/CommonValidation";

const headers = ['Symptoms', 'Area', 'Description', 'Intensity', 'Duration', 'A/R By', 'Action'];
const Intensity = [
    { label: 'Mild', value: 'Mild' },
    { label: 'Moderate', value: 'Moderate' },
    { label: 'Severe', value: 'Severe' },
]
const UnitList = [
    {label: "Minutes", value: "Mins"},
    {label: "Hours", value: "Hours"},
    {label: "Days", value: "Days"},
    {label: "Weeks", value: "Weeks"},
    {label: "Months", value: "Months"}
]
const DocNewPresentComplaints = ({ Title, ...props }) => {
    const [state, setState] = useState({
        isEdit: false,
        symptomsValue: "",
        areaValue: "",
        description: "",
        intensity: "",
        duration: null,
        durationUnit: "",
        arBy: "",
        symptomsList: [],
        AreaList: [],
        newPresentData: [],
        dltLineClk: false,
        selectedId: null,
        removeLineData: false,
    })
    const updateState = (updates) => {
        setState((prev) => ({ ...prev, ...updates }));
    };

    const getApiCall = useCallback(() => {
        getNewPresentComplaintData();
        getSymptomsData();
        getAreaData();
    }, [props.appointmentId, props.isFromIp, props.ipAdmissionId]);

    useEffect(() => {
        props.registerRefreshFunction("new_presenting_complaints", getNewPresentComplaintData);
    }, []);

    const getNewPresentComplaintData = () => {
        const { appointmentId, ipAdmissionId, clinicId, doctorId, isFromIp } = props
        try {
            const params = isFromIp ? `?ip_admission_id=${ipAdmissionId}&clinic_id=${clinicId}&doctor_id=${doctorId}` : `?appointment_id=${appointmentId}`
            RestAPIService.getAll(Serviceurls.AYURVEDA_NEW_COMPLAINTS + params)
                .then((response) => {
                    if (response.data.status === "success") {
                        updateState({ newPresentData: response?.data?.data || [], })
                    } else {
                        props.errorMessage(response.data.message)
                    }
                }).catch((error) => {
                    props.errorMessage(error?.response?.data?.message || error?.message)
                })
        }
        catch (e) {
            props.errorMessage(e.message)
        }
    }

    const getSymptomsData = () => {
        try {
            RestAPIService.getAll(Serviceurls.AYURVEDA_SYMPTOMS_MASTER)
                .then((response) => {
                    if (response.data.status === "success") {
                        updateState({ symptomsList: response?.data?.data?.filter(i => i.is_active) || [], })
                    } else {
                        props.errorMessage(response.data.message)
                    }
                }).catch((error) => {
                    props.errorMessage(error?.response?.data?.message || error?.message)
                })
        }
        catch (e) {
            props.errorMessage(e.message)
        }
    }

    const getAreaData = () => {
        try {
            RestAPIService.getAll(Serviceurls.AYURVEDA_AREA_MASTER)
                .then((response) => {
                    if (response.data.status === "success") {
                        updateState({ AreaList: response?.data?.data?.filter(i => i.is_active) || [], })
                    } else {
                        props.errorMessage(response.data.message)
                    }
                }).catch((error) => {
                    props.errorMessage(error?.response?.data?.message || error?.message)
                })
        }
        catch (e) {
            props.errorMessage(e.message)
        }
    }

    const onClearHandler = () => {
        updateState({
            isEdit: false,
            symptomsValue: "",
            areaValue: "",
            description: "",
            intensity: "",
            duration: null,
            durationUnit: "",
            arBy: "",
            selectedId: null,
        })
    }

    const deleteLinePop = () => {
        updateState({
            dltLineClk: false,
            deleteLineItem: null,
            removeLineData: false,
        })
    }

    const deleteLineItem = () => {
        try {
            updateState({ removeLineData: true });
            RestAPIService.delete(`${Serviceurls.AYURVEDA_NEW_COMPLAINTS + state.deleteLineItem?.id}/`)
                .then(response => {
                    if (response.data.status === "success") {
                        props.successMessage(response.data.message);
                        deleteLinePop();
                        getNewPresentComplaintData();
                    }
                })
                .catch(e => {
                    updateState({ removeLineData: false });
                    props.errorMessage(e.response.data.message || e.message)
                });
        } catch (e) {
            updateState({ removeLineData: false });
            props.errorMessage(e.message);
        }
    }

    const postExamination = () => {
        const { appointmentId, ipAdmissionId, clinicId, doctorId, isFromIp } = props
        try {
            const data = {
                "id": state.selectedId ? state.selectedId : null,
                "symptom": state.symptomsValue ? state.symptomsValue?.id : null,
                "area": state.areaValue ? state.areaValue?.id : null,
                "intensity": state.intensity ? state.intensity : "",
                "description": state.description ? state.description : "",
                "duration_value": state.duration ? state.duration : "",
                "duration_unit": state.durationUnit ? state.durationUnit : "",
                "ar_by": state.arBy ? state.arBy : "",
            }
            if (isFromIp) {
                data.ip_admission_id = ipAdmissionId
                data.clinic_id = clinicId
                data.doctor_id = doctorId
            } else {
                data.appointment_id = appointmentId
            }

            let params = Serviceurls.AYURVEDA_NEW_COMPLAINTS
            const apiCall = state.selectedId
                ? RestAPIService.update(state.selectedId, data, params) : RestAPIService.create(data, params);

            updateState({ postLoading: true })
            apiCall
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        props.successMessage(response?.data?.message)
                        onClearHandler()
                        getNewPresentComplaintData();
                        updateState({ postLoading: false })
                    }
                }).catch((error) => {
                    updateState({ postLoading: false })
                    props.errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            updateState({ postLoading: false })
            props.errorMessage(error.message)
        }
    }

    const renderAutoComplete = (label, statekey, list, showKey) => {
        const selectedValue = state[statekey] || "";
        return (
            <Autocomplete
                size="small"
                options={list || []}
                sx={{ width: "100%" }}
                getOptionLabel={(option) => (typeof option === "string" ? option : option[showKey] || "")}
                value={selectedValue}
                onChange={(event, newValue) => {
                    if (statekey === "symptomsValue") {
                        if (newValue) {
                            updateState({
                                symptomsValue: newValue,
                            });
                        } else {
                            onClearHandler()
                        }
                    } else if (statekey === 'areaValue') {
                        updateState({ areaValue: newValue });
                    }
                }}
                renderOption={(props, option) => (
                    <li {...props} style={{ padding: '0vh 1.5vh' }}>
                        <ListItem sx={{ display: 'flex', justifyContent: 'space-between', p: 0, m: 0 }}>
                            <ListItemText
                                primary={
                                    option[showKey]?.length > 30 ? (
                                        <Tooltip title={option[showKey]} placement="top">
                                            <div>{option[showKey]?.slice(0, 21) + '...'}</div>
                                        </Tooltip>
                                    ) : (
                                        option[showKey]
                                    )
                                }
                            />
                        </ListItem>
                    </li>
                )}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        size='small'
                        label={label}
                        autoComplete="off"
                        inputProps={{
                            ...params.inputProps,
                        }}
                    />
                )}
            />
        );
    };

    const renderTextField = (label, stateKey, mr = "", maxLength, width = "12dvw") => {
        return (
            <TextField
                size='small'
                autoComplete='off'
                sx={{ mr: mr, width: width }}
                label={label}
                value={state[stateKey] || ""}
                inputProps={{ maxLength: maxLength }}
                onChange={(e) => {
                    if(stateKey == "duration"){
                        if(CommonValidation.numberOnly(e.target.value) || e.target.value == ""){
                            updateState({ [stateKey]: e.target.value })    
                        }
                    }
                    else{
                        updateState({ [stateKey]: e.target.value })
                    }
                }}
            />
        )
    }

    const renderSelect = (stateKey, isDisable, list = [], width, showKey = "label", valueKey = "value") => {
    return (
      <Select
        sx={{ width: width, fontSize: '0.95vw' }}
        size='small'
        value={state[stateKey]}
        onChange={(e) => { updateState({ [stateKey]: e.target.value, oxygen_support: "" }) }}
        disabled={isDisable}
      >
        {list?.map((item) => (
          <MenuItem sx={{ fontSize: '0.95vw' }} key={item[valueKey]} value={item[valueKey]}>{item[showKey]}</MenuItem>
        ))}
      </Select>
    )
  }

    const disableBtn = useMemo(() => {
        return !(state.symptomsValue && state.areaValue) || props.isLocked;
    }, [state.symptomsValue, state.areaValue, props.isLocked]);

    return (
        <ShowComponents onIntersection={getApiCall}>
            <Card sx={{
                width: "100%", height: "fit-content", padding: "0.3vw",
                marginBottom: "0.5vw", border: `2px solid ${props.isSelected ? Colors.themeDark : Colors.white}`
            }}>
                <Box display={"flex"} flexDirection={'row'} alignItems={"center"} justifyContent={'space-between'} padding={"0.5vw"} borderBottom={`1px solid #E3E2E2`}>
                    {renderTitle(Title, props.isSelected)}
                </Box>
                <Table size='small' stickyHeader aria-label="sticky table" sx={{ maxHeight: '20vw', overflowY: 'auto' }}>
                    <TableHead>
                        <TableRow>
                            {headers.map((text, idx) => (
                                <TableCell
                                    key={idx}
                                    align={headers.length - 1 === idx ? "center" : "left"}
                                    sx={{
                                        fontWeight: 600,
                                        fontSize: '0.9vw',
                                        color: Colors.SecondaryText,
                                        backgroundColor: Colors.Background,
                                        px: '0.2vw'
                                    }}
                                >
                                    {text}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow sx={{ height: '3vw', '& td': { px: '0.2vw', verticalAlign: 'middle' } }}>
                            <TableCell align="left" sx={{ width: "14vw" }}>
                                {renderAutoComplete("Symptoms *", "symptomsValue", state.symptomsList, 'symptom_name')}
                            </TableCell>
                            <TableCell align="left" sx={{ width: "12vw" }}>
                                {renderAutoComplete("Area *", "areaValue", state.AreaList, "area_name")}
                            </TableCell>
                            <TableCell align="left" sx={{ width: "12vw" }}>
                                {renderTextField("Description", "description", "", 250, "12dvw")}
                            </TableCell>
                            <TableCell align="left" sx={{ width: "10vw" }}>
                                {renderSelect("intensity", props.isLocked, Intensity, "8dvw", "label", "value")}
                            </TableCell>
                            <TableCell align="left" sx={{ width: "18vw" }}>
                                {renderTextField("Duration", "duration", "", 3, "4dvw")}
                                {renderSelect("durationUnit", props.isLocked, UnitList, "6vw", "label", "value")}
                            </TableCell>
                            <TableCell align="left" sx={{ width: "10vw" }}>
                                {renderTextField("A/R By", "arBy", "", 100, "10vw")}
                            </TableCell>
                            <TableCell align="center" sx={{ width: "1vw" }}>
                                {renderIconButton('Add', disableBtn ? ImagePaths.DisabledAddIcon.default : ImagePaths.AddIcon.default, postExamination, disableBtn, "2vw")}
                            </TableCell>
                        </TableRow>
                        {
                            state.newPresentData?.length > 0 ? state.newPresentData?.map((item, index) => (
                                <TableRow key={index} sx={{ '& td': { pl: '0.3vw', pr: "0.2vw", fontSize: "0.9vw" } }}>
                                    <TableCell align="left">{item?.symptom_details?.symptom_name ? item?.symptom_details?.symptom_name?.length > 18 ?
                                        <Tooltip placement='top' title={item?.symptoms?.symptom_name} arrow>
                                            <div>{item?.symptom_details?.symptom_name.slice(0, 15) + "..."}</div></Tooltip> :
                                        item?.symptom_details?.symptom_name : "-"}</TableCell>
                                    <TableCell align="left">
                                        {item?.area_details?.area_name ? item?.area_details?.area_name?.length > 18 ?
                                            <Tooltip placement='top' title={item?.area_details?.area_name} arrow>
                                                <div>{item?.area_details?.area_name.slice(0, 18) + "..."}</div></Tooltip> :
                                            item?.area_details?.area_name : "-"}
                                    </TableCell>
                                    <TableCell align="left">
                                        {item?.description ? item?.description?.length > 30 ?
                                            <Tooltip placement='top' title={item?.description} arrow>
                                                <div>{item?.description.slice(0, 28) + "..."}</div></Tooltip> :
                                            item?.description : "-"}
                                    </TableCell>
                                    <TableCell align="left">
                                        {item?.intensity ? <div>{item?.intensity}</div> : "-"}
                                    </TableCell>
                                    <TableCell align="left">
                                        {item?.intensity ? <div>{item?.duration_value + " " + item?.duration_unit}</div> : "-"}
                                    </TableCell>
                                    <TableCell align="left">
                                        {item?.ar_by ? item?.ar_by?.length > 30 ?
                                            <Tooltip placement='top' title={item?.ar_by} arrow>
                                                <div>{item?.ar_by.slice(0, 28) + "..."}</div></Tooltip> :
                                            item?.ar_by : "-"}
                                    </TableCell>
                                    <TableCell align="center">
                                        <Box component={'div'} display={'flex'}>
                                            <CommonEditButton disable={state.dltLineClk || props.isLocked} size={"1.5vw"}
                                                onClick={() => {
                                                    updateState({
                                                        isEdit: true,
                                                        selectedId: item?.id,
                                                        symptomsValue: item?.symptom_details,
                                                        areaValue: item?.area_details,
                                                        description: item?.description || "",
                                                        intensity: item?.intensity || "",
                                                        duration: item?.duration_value,
                                                        durationUnit: item?.duration_unit,
                                                        arBy: item?.ar_by || "",
                                                    })
                                                }} />
                                            <CommonDeleteButton disable={state.isEdit || state.dltLineClk || props.isLocked} size={"1.5vw"}
                                                onClick={() => {
                                                    updateState({
                                                        dltLineClk: true,
                                                        deleteLineItem: item,
                                                    })
                                                }} />
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            )) : <TableRow>
                                <TableCell colSpan={headers.length} align="center">
                                    No Records To Be Shown
                                </TableCell>
                            </TableRow>}
                    </TableBody>
                </Table>
                {state.dltLineClk && <DeletePopup
                    DeletTitle={`Are you sure you want to delete ?`}
                    deleteAlertPopupClose={deleteLinePop.bind(this)}
                    removeData={deleteLineItem.bind(this)}
                    disable={state.removeLineData}
                />}
            </Card>
        </ShowComponents >
    )
}

export default DocNewPresentComplaints